const { h, render, Component } = require('preact');
const GrouponValidate = require ("../../../groupon/frontend/validate")

class UserIdentification extends Component {
  constructor(props) {
    super(props);
    this.changeUserIdentificationState = this.changeUserIdentificationState.bind(this)
    this.validateEmailId = this.validateEmailId.bind(this)
  }

  getUserNameElement() {
    return document.getElementById('tcktUsername')
  }

  getUserEmailElement() {
    return document.getElementById('tcktUsermail')
  }

  changeUserIdentificationState () {
    this.props.updateState(this.props.attrs.type, this.props.attrs.counter, this.populateInput(), this.isInputValid())
  }

  validateEmailId() {
    var email_id = this.getUserEmailElement().value.trim()
    if (GrouponValidate.email(email_id)) {
      document.getElementById("validateUserContactEmail").style.display = 'none'
      return true
    }
    else
      document.getElementById("validateUserContactEmail").style.display = 'block'
      return false
  }

  componentDidMount() {
    this.getUserNameElement().addEventListener("keyup", this.changeUserIdentificationState)
    this.getUserEmailElement().addEventListener("keyup", this.changeUserIdentificationState)
  }

  isInputValid() {
    if (this.props.attrs.required == "true") {
     return  this.isInputGiven() && this.validateEmailId()
    }
    return true
  }

  populateInput() {
    var data = {
      user_name: this.getUserNameElement().value.trim(),
      user_email: this.getUserEmailElement().value.trim(),
      userIdentificationview: true
    }
    return data
  }

  isInputGiven() {
    return (this.getUserEmailElement().value.trim().length > 0) && (this.getUserNameElement().value.trim().length > 0)
  }

  render() {

    return (
      <div>
          <label>
            <strong>{I18n.translate('js.modules.support.userlabel')}
              <span class="mandatory-field">* </span>
            </strong>
          </label>
          <input class="inputField userName" id="tcktUsername" size="40" maxLength="250" type="text" name="username"/>

          <label>
            <strong>{I18n.translate('js.modules.support.emaillabel')}
              <span class="mandatory-field">* </span>
            </strong>
          </label>
          <input class="inputField" id="tcktUsermail" type="text" name="email" size="40" maxLength="250"/>
          <span id="validateUserContactEmail" style="display:none"
                class="error invalid-input initially-hidden">{I18n.translate('js.modules.support.invalidemail')}</span>
      </div>
    )
  }
}

module.exports = UserIdentification
